import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "bootstrap-icons/font/bootstrap-icons.css";
import process from 'process';
// import "./Components/Agency/AgencyDashboard/AgencySubscriptionCard.css";
// import "./Components/Agency/AgencyDashboard/CandidatesStatsCard.css";
// import "./Components/Agency/AgencyDashboard/EmployerInteractionCard.css";
// import "./Components/Agency/AgencyDashboard/RecentCVsCard.css";
// import "./Components/Agency/AgencyDashboard/ReportsAnalyticsCard.css";

// Suppress known harmless "Script error." originating from React hot-reloading
// when trying to interact with cross-origin iframes like YouTube embeddings.
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.') {
    e.stopImmediatePropagation();
  }
});

// Polyfill for browser usage by deps that expect Node's process.
window.process = process;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
